import styled, { css } from 'styled-components';
import { colors, layout, remCalc } from '@prisjakt/ui-base';
import { LabelStyle } from './types';

type CheckboxProps = { disabled?: boolean };

export const Checkbox = styled.div<CheckboxProps>`
  user-select: none;
  font-weight: normal;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

export const Input = styled.input`
  appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;

type CheckIconWrapperProps = {
  checked?: boolean;
  partial?: boolean;
};

export const CheckIconWrapper = styled.span<CheckIconWrapperProps>(
  props => css`
    display: flex;
    border: 1px solid ${props.theme.lines.secondary};

    ${Input} {
      &:focus + & {
        border-color: ${colors.lightBlue3};
        outline: 1px solid ${colors.lightBlue3};
      }
    }

    svg {
      position: relative;
      left: 1px;
      top: 1px;
      stroke-width: 6px;
      path {
        stroke: ${colors.white};
        fill: none;
      }
    }

    ${(props.checked || props.partial) &&
      css`
        background-color: ${colors.lightBlue1};
        border-color: ${colors.lightBlue1};
        outline: 1px solid ${colors.lightBlue1};

        svg {
          background-color: ${colors.lightBlue1};
        }

        ${Input}:focus + & {
          background-color: ${colors.lightBlue3};
          border-color: ${colors.lightBlue3};
          outline: 2px solid ${colors.lightBlue3};
          svg {
            background-color: ${colors.lightBlue3};
          }
        }
      `};

    ${(props.checked || props.partial) &&
      css`
        svg {
          background-color: ${props.theme.lines.highlight};
        }
      `};
  `
);

type LabelTextProps = {
  labelStyle: LabelStyle;
};

export const LabelText = styled.span<LabelTextProps>`
  margin-left: ${layout.listSideMargin};
  display: flex;
  flex-direction: column;
  color: ${colors.darkGray4};

  ${props =>
    props.labelStyle === 'bold' &&
    css`
      color: ${p => p.theme.text.callToAction};
      font-weight: 600;
    `}
`;

type LabelProps = { disabled?: boolean };

export const Label = styled.label<LabelProps>(
  props => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    position: relative;

    ${!props.disabled &&
      css`
        ${LabelText} {
          &:hover {
            color: ${props.theme.text.callToActionHover};
          }
        }
      `}

    ${props.disabled &&
      css`
        cursor: no-drop;
      `}
  `
);

type HelperProps = { warning?: boolean };
export const Helper = styled.span<HelperProps>`
  font-size: ${remCalc(12)};
  color: ${props => (props.warning ? colors.red1 : colors.darkGray1)};
  width: 100%;
`;
